import React, { useEffect, useState } from 'react';
import {makeStyles} from "@material-ui/core/styles";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import '@fontsource/inter';

import Color from '../utils/colors';

const useStyles = makeStyles(() => ({
  inputStyleContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  inputStyle: {
    width: '100%',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: props => props.borderColor,
    padding: '10px 12px',
    fontFamily: 'Inter, Roboto, sans-serif',
    fontSize: '16px',
    transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    backgroundColor: 'white',
    '&:focus': {
      borderColor: props => props.borderColorFocused,
      borderWidth: '3px',
      outline: '-webkit-focus-ring-color auto 0px'
    },
    '&:disabled': {
      backgroundColor: 'LightGrey'
    },
  },
  charsLeftCountValue: {
    fontSize: '12px'
  },
  charsLeftCountValueInError: {
    fontSize: '12px',
    color: 'red'
  }
}));

export default function EnhancedTextInput({validate,
                                            maxText,
                                            changeMethod,
                                            initialValue='',
                                            maxRows,
                                            autoFocus=false,
                                            placeholder,
                                            regexValidation,
                                            disabled,
                                            onBlurHandler,
                                            className}) {

  const [ charsLeftCountValue, setCharsLeftCountValue ] = useState(0);

  useEffect(() => {
    const value = initialValue || '';
    const charsLeft = maxText - value.length;
    if (charsLeft < 0) {
      initialValue = initialValue.substring(0, maxText);
      changeMethod(initialValue);
    }

    setCharsLeftCountValue(charsLeft);
  }, [ initialValue ]);

  const borderColor = validate && (!initialValue || initialValue.length === 0)? 'red' : Color.primary;
  const classes = useStyles({borderColor, borderColorFocused: Color.tertiary});

  const handleChange = event => {
    const targetValue = event.target.value;
    if (regexValidation && !regexValidation.exec(targetValue)  && targetValue.length !== 0) {
      return;
    }
    if ( targetValue.length <= maxText) {
      if (changeMethod) {
        changeMethod(targetValue);
      }
      setCharsLeftCountValue(maxText - targetValue.length);
    }
  };

  const getClassName = () => {
    return className? `${className} ${classes.inputStyle}` : classes.inputStyle;
  };

  const getCharsLeftCountClassName = () => {
    return charsLeftCountValue > 0? classes.charsLeftCountValue : classes.charsLeftCountValueInError;
  }

  return (
    <div className={classes.inputStyleContainer}>
      <TextareaAutosize
        rowsMax={maxRows}
        aria-label="maximum height"
        placeholder={placeholder}
        className={getClassName()}
        variant="outlined"
        onChange={handleChange}
        value={initialValue}
        autoFocus={autoFocus}
        disabled={disabled}
        onBlur={onBlurHandler}
      />
      <span className={getCharsLeftCountClassName()}>Characters left: {charsLeftCountValue}</span>
    </div>
  );
}
